import type { ReactNode } from 'react';

import { cn } from '../../lib/utils';

export function Alert({
  variant = 'default',
  title,
  children,
  className,
}: {
  variant?: 'default' | 'destructive' | 'warning' | 'success';
  title?: ReactNode;
  children?: ReactNode;
  className?: string;
}) {
  return (
    <div
      role={variant === 'destructive' ? 'alert' : 'status'}
      className={cn(
        'rounded-md border p-3 text-sm',
        variant === 'destructive' && 'border-destructive/50 bg-destructive/10 text-destructive',
        variant === 'warning' && 'border-amber-300 bg-amber-50 text-amber-900',
        variant === 'success' && 'border-emerald-300 bg-emerald-50 text-emerald-900',
        className,
      )}
    >
      {title ? <p className="mb-1 font-medium">{title}</p> : null}
      {children ? <div className="whitespace-pre-line">{children}</div> : null}
    </div>
  );
}
